import experimentSingleton from '../vendor/experiment.vendor'

export const RECIPIENTS_FEATURE_FLAGS = {
  RegisterInformationEditEnabled:
    'gvcp_recipients_register_information_edit_enabled'
}

async function isRecipientsRegisterInformationEditFlagEnabled () {
  return await experimentSingleton.isFlagActive(
    RECIPIENTS_FEATURE_FLAGS.RegisterInformationEditEnabled
  )
}

export { isRecipientsRegisterInformationEditFlagEnabled }
